import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UserCircle } from 'lucide-react';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, } from '../../ui/dropdown-menu';
import { useAuth } from 'react-oidc-context';
import { Button } from '../../ui/button';
import { clearSelectedEnvironment } from '../../lib/environmentStorage';
export const ProfileDropdown = () => {
    const auth = useAuth();
    const handleSignout = async () => {
        // Clear selected environment on logout
        clearSelectedEnvironment();
        await auth.signoutPopup();
    };
    return (_jsxs(DropdownMenu, { children: [_jsx(DropdownMenuTrigger, { asChild: true, children: _jsx(Button, { variant: "ghost", size: "icon", children: _jsx(UserCircle, {}) }) }), _jsxs(DropdownMenuContent, { className: "bg-opacity-100 bg-white", align: "end", children: [_jsx(DropdownMenuLabel, { children: "My account" }), _jsx(DropdownMenuItem, { title: auth.user?.profile.email, children: auth.user?.profile.name }), _jsx(DropdownMenuSeparator, { className: "bg-gray-300" }), _jsx(DropdownMenuItem, { className: "focus:cursor-pointer focus:outline-gray-400", onClick: async () => {
                            await handleSignout();
                        }, children: "Logout" })] })] }));
};
